import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';
import { Link } from 'shared/components/Link';

import * as styles from './styles.css';

interface INewbuildingBrochureProps {
  onClick(): void;
  url: string;
}

export const NewbuildingBrochure = ({ onClick, url }: INewbuildingBrochureProps) => {
  return (
    <div data-testid="NewbuildingBrochure" className={styles['container']}>
      <div className={styles['title']}>
        <UIText1 color="text-secondary-default">Брошюра ЖК</UIText1>
      </div>
      <Link target="_blank" url={url} onClick={onClick}>
        <div className={styles['link-with-icon']}>
          Смотреть
          <div className={styles['target-link-icon']}></div>
        </div>
      </Link>
    </div>
  );
};
